import React from "react";

export const CourseCircleIcon = (props) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32 0.912109C49.3218 0.912109 63.3545 14.8357 63.3545 32C63.3545 49.1643 49.3217 63.0879 32 63.0879C14.6783 63.0879 0.645542 49.1643 0.645508 32C0.645508 14.8357 14.6782 0.912109 32 0.912109Z"
        fill="white"
        stroke="#E4E4E4"
        strokeWidth="1.29081"
      />
      <path
        d="M25.9146 25.9688V38.4285"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.1963 30.122V34.2752C32.1963 35.3767 32.6375 36.4331 33.423 37.212C34.2084 37.9909 35.2737 38.4285 36.3844 38.4285C37.4952 38.4285 38.5605 37.9909 39.3459 37.212C40.1313 36.4331 40.5726 35.3767 40.5726 34.2752V30.122C40.5726 29.0205 40.1313 27.9641 39.3459 27.1852C38.5605 26.4063 37.4952 25.9688 36.3844 25.9688C35.2737 25.9688 34.2084 26.4063 33.423 27.1852C32.6375 27.9641 32.1963 29.0205 32.1963 30.122Z"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3496 32.1978V32.2178"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.042 32.1978V32.2178"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.1963 50.8877V50.9077"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7729 15.9985V16.0186"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.6187 48.397V48.417"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7729 48.397V48.417"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8628 41.5405V41.5606"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.5303 41.5405V41.5606"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8628 22.8467V22.8667"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.551 22.9087C46.9022 20.0514 44.5212 17.677 41.6491 16.0261C38.777 14.3752 35.516 13.5065 32.1963 13.5078"
        stroke="#18428E"
        strokeWidth="2.53115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
